import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timestamp"]
  static values = { url: String }
  send(event) {
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ notification_sent_at: new Date().toISOString() })
    })
      .then(response => response.json())
      .then(data => {
        this.timestampTarget.textContent =
          `Gesendet: ${data.notification_sent_at}`
      })
  }
}
